import AdminPermissionManage from './AdminPermissionManage';

/** @deprecated 관리자권한설정으로 통합 — 즐겨찾기·구 URL 호환 */
export default function ResponsibilityPermissionManage() {
  return <AdminPermissionManage />;
}
